import { render } from "./SparkBotSettings.vue?vue&type=template&id=ecf3a428"
import script from "./SparkBotSettings.vue?vue&type=script&lang=js"
export * from "./SparkBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__